module.exports = __webpack_public_path__ + "img/Apt.f1bd7317.png";